export default {
  batch: {
    status: "Status",
    totalDistance: "Gesamtstrecke (km)",
    productionEmission: "Produktions-Emission (kg CO2e)",
    transportEmission: "Transport-Emission (kg CO2e)",
    totalEmission: "Gesamt-Emission (kg CO2e)",
    tax: "Steuer (€)",
    more: "Mehr",
    fallbackDistanceWarning: "Strecke mit Ausweichmethode berechnet, kann Fehler enthalten",
  },
  label: {
    start: "Start",
    end: "Ende",
    via: "Via",
    mode: "Transportmodus",
    weight: "Gewicht",
    cnCode: "KN-Code",
  },
  placeholder: {
    start: "z.B. Shanghai, CN",
    end: "z.B. Rotterdam, NL",
    via: "z.B. Singapur, SG",
    mode: "Transportmodus",
    weight: "Gewicht eingeben",
    cnCode: "z.B. 25070080 oder Zement",
    location: "z.B. Shanghai, CN",
  },
  action: {
    addVia: "Zwischenstopp hinzufügen",
    remove: "Entfernen",
    calculate: "Berechnen",
    loadMore: "Mehr laden",
  },
  transport: {
    sea: "See",
    road: "Straße",
    rail: "Schiene",
    barge: "Kahn",
  },
  unit: {
    tonne: "Tonne",
    kilogram: "Kilogramm",
    pound: "Pfund",
  },
  leg: {
    enable_detailed_mode: "Detaillierten Modus aktivieren, um Emissionsfaktoren anzuzeigen",
    detailed_mode: "Detaillierter Modus",
    simple_mode: "Einfacher Modus",
    origin: "Herkunft",
    destination: "Ziel",
    transport_mode: "Transportmodus",
    distance: "Strecke (km)",
    weight: "Gewicht (t)",
    cn_code: "KN-Code",
    transport_emission: "Transport-Emission (kg CO2e)",
    transport_emission_factor: "Transport-Emissionsfaktor",
    transport_emission_factor_id: "Transport-Emissionsfaktor-ID",
    production_emission: "Produktions-Emission (kg CO2e)",
    production_emission_factor: "Produktions-Emissionsfaktor",
    production_emission_factor_id: "Produktions-Emissionsfaktor-ID",
    total_emission: "Gesamt-Emission (kg CO2e)",
  },
  error: {
    cnCodeSearchFailed: "KN-Code-Suche fehlgeschlagen",
    cnCodeSearchFailedDesc:
      "Verfügbare KN-Codes können nicht abgefragt werden, bitte überprüfen Sie das Netzwerk.",
    locationRequired: "Bitte geben Sie einen Standort ein",
    modeRequired: "Bitte wählen Sie einen Transportmodus aus",
    requiredFields: "Bitte füllen Sie alle Pflichtfelder aus",
    calculationFailed: "Berechnung fehlgeschlagen",
    checkInputs: "Bitte überprüfen Sie die Eingaben oder versuchen Sie es später erneut",
    cnCodeRequired: "Bitte geben Sie den KN-Code ein",
    weightRequired: "Bitte geben Sie das Gewicht ein",
    maxViaPoints: "Maximal 3 Zwischenstopps erlaubt",
    cnCodeInvalid:
      "KN-Code darf nur Buchstaben, Zahlen und Unterstriche enthalten, maximal 20 Zeichen",
    weightPositive: "Gewicht muss positiv sein",
    locationSearchFailed: "Standortsuche fehlgeschlagen",
    locationSearchFailedDesc:
      "Verbindung zum Standortdienst nicht möglich, bitte versuchen Sie es später erneut.",
  },
  result: {
    title: "Berechnungsergebnis",
    selected: "Ausgewählte Option",
    alternative: "Empfohlene Option ({mode})",
    leg: "Abschnitt {index}",
    totalDistance: "Gesamtstrecke",
    productionEmission: "Produktions-Emission",
    transportEmission: "Transport-Emission",
    totalEmission: "Gesamt-Emission",
    tax: "Kohlenstoffsteuer",
  },
  page: {
    title: "CBAM-Emissionsrechner",
    single: "Einzelberechnung",
    batchTitle: "Batch-Berechnung",
    batch: {
      rowNumber: "Zeile",
      cnCode: "KN-Code",
      weight: "Gewicht (t)",
      originCity: "Herkunftsstadt",
      originCoords: "Herkunftskoordinaten",
      destinationCity: "Zielstadt",
      destinationCoords: "Zielkoordinaten",
      transportMode: "Transportmodus",
      error: "Fehler",
      errorRowsDetected:
        "{count} fehlerhafte Zeilen erkannt, automatisch ausgeschlossen. Nur {validCount} gültige Zeilen gespeichert.",
      errors: {
        invalidCsvHeader: "Ungültiger CSV-Header",
        headerMustBe: "Header muss genau sein: {fields}",
        batchSizeExceed: "Batch-Größe darf {maxSize} nicht überschreiten",
        csvValidationFailed: "CSV-Validierung fehlgeschlagen",
        checkFormat: "Format überprüfen oder erneut versuchen",
        invalidXlsxFile: "Ungültige XLSX-Datei",
        fileIsEmpty: "Datei ist leer",
        invalidXlsxHeader: "Ungültiger XLSX-Header",
        xlsxValidationFailed: "XLSX-Validierung fehlgeschlagen",
      },
    },
    upgradeTip:
      "Upgraden Sie auf Pro, um segmentiertes Gewicht und KN-Code-Berechnung freizuschalten und die CBAM-Compliance-Genauigkeit zu verbessern!",
    learnMore: "Mehr erfahren",
    reportTitle: "Emissionsbericht",
    viewReport: "Bericht anzeigen",
    totalOverview: "Gesamtübersicht",
    origin: "Herkunft",
    destination: "Ziel",
    totalDistance: "Gesamtstrecke",
    tax: "Steuer",
    basedOnEUR: "Basierend auf €{amount}",
    productionEmission: "Produktions-Emission",
    transportEmission: "Transport-Emission",
    totalEmission: "Gesamt-Emission",
    pleaseCalculateFirst: "Bitte zuerst berechnen",
    batchLimitInfo:
      "Kostenlose Nutzer unterstützen bis zu 10 Datensätze, zahlende Nutzer bis zu 200 Datensätze.",
    clearErrorData: "Fehlerdaten löschen",
    submitCalculation: "Berechnung absenden",
    confirmDeleteTask: "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
    reupload: "Erneut hochladen",
    uploadHint: "Klicken oder ziehen Sie die Datei in diesen Bereich, um sie hochzuladen",
    csvOnlyHint:
      "Die kostenlose Version unterstützt nur CSV, zahlende Nutzer unterstützen CSV und XLSX",
    configFailed: "Konfiguration konnte nicht abgerufen werden, bitte erneut versuchen",
    batchResultSummary:
      "Insgesamt {total} Datensätze, {success} erfolgreich, {fail} fehlgeschlagen",
    searchByCNCode: "Nach KN-Code suchen",
    downloadCSVTemplate: "CSV-Vorlage herunterladen",
    downloadXLSXTemplate: "XLSX-Vorlage herunterladen",
    previewReport: "Berichtsvorschau",
    to: "bis",
    // Vorlagen-bezogene Übersetzungen
    template: {
      saveTemplate: "Vorlage speichern",
      templateName: "Vorlagenname",
      namePlaceholder: "Bitte Vorlagennamen eingeben",
      nameRequired: "Bitte Vorlagennamen eingeben",
      nameTooLong: "Vorlagenname darf 50 Zeichen nicht überschreiten",
      formIncomplete: "Bitte vervollständigen Sie das Formular vor dem Speichern der Vorlage",
      saveSuccess: "Vorlage erfolgreich gespeichert",
      saveFailed: "Speichern der Vorlage fehlgeschlagen",
    },
  },
  tooltip: {
    cnCode: "KN-Code besteht aus Buchstaben, Zahlen und Unterstrichen, bis zu 20 Zeichen",
  },
  progress: {
    title: "Batch-Berechnung",
    stages: {
      connecting: "Verbinden",
      connected: "Verbunden",
      validating: "Validieren",
      validated: "Validiert",
      calculating: "Berechnen",
      completed: "Berechnung abgeschlossen",
    },
    close: "Schließen",
    regenerate: "Neu generieren",
    addFactor: "Faktor hinzufügen",
  },
  location: {
    noMatch: "Keine passenden Ergebnisse",
    enterKeyword: "Bitte geben Sie ein Stichwort ein",
  },
  plan: {
    trialExceeded: "Testberechnungen überschritten ({count})",
    trialExpired: "Testphase abgelaufen",
    monthlyExceeded: "Monatliche Berechnungen überschritten ({count})",
    subscriptionExpired: "Abonnementperiode abgelaufen",
  },
};
